import { DecisionsRevisitWidget } from "../../decisions-revisit-widget.js";

/**
 * Phase 13.5 widget — decisions-to-revisit list (re-export wrapper to
 * keep the registry's `Component` lookup uniform).
 */
export function DecisionsRevisitWidgetWrapper() {
  return <DecisionsRevisitWidget />;
}
